/*eslint-disable*/
// init
export const INIT_LIST='INIT_LIST';
export const FRONTCONFIG_LIST='FRONTCONFIG_LIST';


export const SET_USER_INFO = 'SET_USER_INFO';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const LOGIN = 'LOGIN';
export const LOGIN_OUT = 'LOGIN_OUT';
export const CLOSE_INDEX_AD = 'CLOSE_INDEX_AD';
// HOMEBEFORE
export const SET_NAV_LIST = 'SET_NAV_LIST';
export const SET_SLOT_PICLINK = 'SET_SLOT_PICLINK';
export const SET_SLOT_PLATFORM = 'SET_SLOT_PLATFORM';
export const ADD_SLOT_JACKPOT = 'ADD_SLOT_JACKPOT'; // 奖池金额
export const ADD_SLOT_JACKPOT3 = 'ADD_SLOT_JACKPOT3';



// 登陆后
export const SET_SLOT_COLLECTION = 'SET_SLOT_COLLECTION';
export const IS_GET_MYSLOT = 'IS_GET_MYSLOT';


// 多彩宝
export const SET_COLOR_SERVICE = 'SET_COLOR_SERVICE';
export const SET_COLOR_DOWNLOADSHOW = 'SET_COLOR_DOWNLOADSHOW';
export const SET_DOWNLOAD_SHOW = 'SET_DOWNLOAD_SHOW';

// 金沙
export const SET_JIN_SERVICE = 'SET_JIN_SERVICE';
export const SET_JIN_DOWNLOADSHOW = 'SET_JIN_DOWNLOADSHOW';
export const SET_JIN_GAMEITEM = 'SET_JIN_GAMEITEM';
export const SET_JUMPLOGIN_SHOW = 'SET_JUMPLOGIN_SHOW';  //跳转登录页显示
export const SET_JUMPLOGIN_HIDE = 'SET_JUMPLOGIN_HIDE';  //跳转登录页隐藏

// Build04
export const SET_Four_SERVICE = 'SET_Four_SERVICE';

//bet365
export const SET_LOGIN_SHOW = 'SET_LOGIN_SHOW';
export const SET_LOGIN_HIDE = 'SET_LOGIN_HIDE';
export const SET_REGISTER = 'SET_REGISTER';


//下载链接

export const GET_DOWNLOAD_URL = 'GET_DOWNLOAD_URL';


//设置老虎机code

export const SET_SLOT_PLATFORMCODE = 'SET_SLOT_PLATFORMCODE';


// WEBPACK FOOTER //
// ./src/common/store/mutation-types.js